import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import ps from '../s.module.less';

export type SetupMethod = 'new' | 'transfer';

type Props = {
    onContinue: (method: SetupMethod) => void;
};

const NEW_BULLETS = [
    'Dedicated fax number for your practice',
    'Start sending and receiving faxes inside Klarity',
    'No paperwork required',
];

const TRANSFER_BULLETS = [
    'Keep your current fax number',
    'Requires porting authorization',
    "We'll guide you through the process",
];

const ChooseMethod = ({ onContinue }: Props) => {
    const [selected, setSelected] = React.useState<SetupMethod | null>(null);

    return (
        <>
            <div className={ps.header}>
                <div className={ps.headerTitle}>Set up your eFax number</div>
                <div className={ps.headerDesc}>Choose how you&apos;d like to get started</div>
            </div>
            <div className={s.optionList}>
                <div
                    className={`${s.optionCard} ${selected === 'new' ? s.selected : ''}`}
                    onClick={() => setSelected('new')}
                >
                    <div className={s.optionHeader}>
                        <div className={s.optionInfo}>
                            <div className={s.optionTitle}>Get a new U.S.-based fax number</div>
                            <div className={s.optionSub}>Instant</div>
                        </div>
                        <div className={s.badge}>Recommended</div>
                    </div>
                    {selected === 'new' && (
                        <ul className={s.expandedBullets}>
                            {NEW_BULLETS.map((t) => (
                                <li key={t}>{t}</li>
                            ))}
                        </ul>
                    )}
                </div>
                <div
                    className={`${s.optionCard} ${selected === 'transfer' ? s.selected : ''}`}
                    onClick={() => setSelected('transfer')}
                >
                    <div className={s.optionHeader}>
                        <div className={s.optionInfo}>
                            <div className={s.optionTitle}>Transfer an existing fax number</div>
                            <div className={s.optionSub}>Usually takes 14-30 days</div>
                        </div>
                    </div>
                    {selected === 'transfer' && (
                        <ul className={s.expandedBullets}>
                            {TRANSFER_BULLETS.map((t) => (
                                <li key={t}>{t}</li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <Button
                type="primary"
                className={ps.actionBtn}
                disabled={!selected}
                onClick={() => selected && onContinue(selected)}
            >
                Continue
            </Button>
        </>
    );
};

export default ChooseMethod;
